import dayjs from "dayjs";
import dayjsTZ from "../../../utils/dayjs";

const CLOCKIN_TYPES_FIELD_NAME = "ClockIn Types";

const normalize = (str) =>
  `${str || ""}`
    .normalize("NFD")
    .replace(/[̀-ͯ]/g, "")
    .trim()
    .toLowerCase();

const isAbsenceOption = (option) =>
  normalize(option?.description).startsWith("mungese") ||
  normalize(option?.name).startsWith("mungese");

export const getAbsenceDayTypes = (programFields) =>
  (
    (programFields || []).find(
      (el) => el?.fieldName === CLOCKIN_TYPES_FIELD_NAME
    )?.fieldOptions || []
  )
    .filter(isAbsenceOption)
    .map((el) => el?.name);

export const getAbsencePunch = (date) =>
  (dayjs.isDayjs(date) ? date : dayjsTZ(date))
    .set("hour", 12)
    .set("minute", 0)
    .set("second", 0)
    .set("millisecond", 0)
    .valueOf();

export const hasNoPunchTimes = (shift) =>
  !!shift?.clockInDate &&
  !!shift?.clockOutDate &&
  dayjsTZ(shift.clockInDate).valueOf() ===
    dayjsTZ(shift.clockOutDate).valueOf();
